<template>
  <h1 class="text-center">Pricing Pages</h1>

</template>

<script>
export default {
  name: "PricingPages"
}
</script>

<style scoped>

</style>